import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import DataTable from '../ui/table';
import StatisticsTerminalExport from './statistics-terminal-export';
var t = i18n.getFixedT(null, 'traffic-prediction');
var Statistics = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  });

  _objectDestructuringEmpty(_useSelector);

  var dispatch = useDispatch();
  var id = props.id;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      currentPage = _useState2[0],
      setCurrentPage = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      totalCount = _useState4[0],
      setTotalCount = _useState4[1];

  var _useState5 = useState(10),
      _useState6 = _slicedToArray(_useState5, 2),
      rowsPerPage = _useState6[0],
      setRowsPerPage = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedItems = _useState8[0],
      setSelectedItems = _useState8[1];

  var _useState9 = useState(''),
      _useState10 = _slicedToArray(_useState9, 2),
      keyword = _useState10[0],
      setKeyword = _useState10[1];

  var _useState11 = useState(),
      _useState12 = _slicedToArray(_useState11, 2),
      detialData = _useState12[0],
      setDetialData = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      openDialog = _useState14[0],
      setOpenDialog = _useState14[1];

  var isMounted = useRef(false);

  var handleChangePage = function handleChangePage() {};

  var handleChangeRowsPerPage = function handleChangeRowsPerPage() {};

  var handleClose = function handleClose() {
    setOpenDialog(false);
  };

  var data = [{
    sequence: 1,
    item: t('lbl-terminal-line-report')
  }];
  var fields = {},
      sort = null;

  _.set(fields, 'sequence', {
    label: t('lbl-sequence'),
    sortable: false
  });

  _.set(fields, 'item', {
    label: t('lbl-name'),
    sortable: false
  });

  _.set(fields, 'more', {
    label: t('lbl-more'),
    sortable: false,
    formatter: function formatter() {
      return /*#__PURE__*/React.createElement("div", {
        className: "icon-block"
      }, /*#__PURE__*/React.createElement("a", null, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-download",
        title: t('lbl-export'),
        onClick: function onClick() {
          return setOpenDialog(true);
        }
      })));
    }
  });

  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: data
  })), openDialog && /*#__PURE__*/React.createElement(StatisticsTerminalExport, {
    onClose: handleClose
  }));
});
Statistics.defaultProps = {
  id: 'g-traffic-prediction-statistics'
};
Statistics.PropTypes = {
  id: PropTypes.string
};
export default Statistics;